import { apiClient } from './apiClient';

export class NotesService {
    constructor() {
        this.BASE_URL = '/notes';
    }

    async createNotes(payload) {
        try {
            const response = await apiClient.post(`${this.BASE_URL}`, payload);
            return response
        } catch (error) {
            console.error('Error creating note:', error);
            throw error;
        }
    }

    async getNotesByEntityTypeAndEntityId(entityType, entityId) {
        try {
            const response = await apiClient.get(`${this.BASE_URL}/entity/${entityType}/${entityId}`);
            return response.data
        } catch (error) {
            console.error('Error fetching notes:', error);
            throw error;
        }
    }

    async getNotesByPatientId(patientId) {
        try {
            const response = await apiClient.get(`${this.BASE_URL}/patient/${patientId}`);
            return response.data
        } catch (error) {
            console.error('Error fetching patient notes:', error);
            throw error;
        }
    }

    async searchNotes({
        orgId,
        queryText = '',
        searchScope = 'all',
        page = 1,
        limit = 20,
        sortBy = 'createdAt',
        sortOrder = 'desc',
        vectorTopK,
        entityType = '',
        entityId = '',
        type = '',
        priority = ''
    } = {}) {
        try {
            const queryParams = new URLSearchParams();

            if (page) queryParams.append('page', page.toString());
            if (limit) queryParams.append('limit', limit.toString());
            if (sortBy) queryParams.append('sortBy', sortBy);
            if (sortOrder) queryParams.append('sortOrder', sortOrder);
            if (queryText) queryParams.append('queryText', queryText);
            if (searchScope) queryParams.append('searchScope', searchScope);
            if (vectorTopK) queryParams.append('vectorTopK', vectorTopK.toString());
            if (entityType) queryParams.append('entityType', entityType);
            if (entityId) queryParams.append('entityId', entityId);
            if (type) queryParams.append('type', type);
            if (priority) queryParams.append('priority', priority);

            const url = `${this.BASE_URL}/search?${queryParams.toString()}`;
            const response = await apiClient.post(url, { orgId });
            return response
        } catch (error) {
            console.error('Error searching notes:', error);
            throw error;
        }
    }

    async setPinned(noteId, pinned) {
        try {
            const response = await apiClient.patch(`${this.BASE_URL}/${noteId}/pin`, { pinned });
            return response
        } catch (error) {
            console.error('Error updating note pin state:', error);
            throw error;
        }
    }

    async updateNotes(noteId, updates) {
        try {
            const response = await apiClient.put(`${this.BASE_URL}/${noteId}`, updates);
            return response
        } catch (error) {
            console.error('Error updating note:', error);
            throw error;
        }
    }
}

export const notesService = new NotesService();
export default notesService;
